// ==========================================
// 1. 基础配置
// ==========================================
const SHOP_DOMAIN = 'abd54e-2.myshopify.com'; 
const STOREFRONT_ACCESS_TOKEN = '7a610d93327e8cc7e2d8f3f2f6569390';
const API_VERSION = '2024-04'; 

// 全局状态：记住当前正在生效的折扣码
let activeDiscountCode = null; 

// ==========================================
// 2. 核心 API 请求方法
// ==========================================
async function shopifyStorefrontRequest(query, variables = {}) {
  const url = `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });

  if (!response.ok) throw new Error(`HTTP 错误: ${response.status}`);
  const result = await response.json();
  if (result.errors) throw new Error(result.errors[0].message);
  return result.data;
}

async function applyDiscountCode(cartId, discountCode) {
  const mutation = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes { code applicable }
          estimatedCost {
            subtotalAmount { amount currencyCode }
            totalAmount { amount currencyCode }
          }
        }
        userErrors { field message }
      }
    }
  `;

  try {
    const data = await shopifyStorefrontRequest(mutation, { cartId, discountCodes: [discountCode] });
    const result = data.cartDiscountCodesUpdate;

    if (result.userErrors && result.userErrors.length > 0) {
      return { success: false, message: result.userErrors[0].message };
    }

    const cart = result.cart;
    const currentDiscount = cart.discountCodes.find(d => d.code.toUpperCase() === discountCode.toUpperCase());

    if (!currentDiscount || !currentDiscount.applicable) {
      return { 
        success: false, 
        message: "折扣码无效或不满足使用条件",
        totalAmount: cart.estimatedCost.totalAmount.amount
      };
    }

    return {
      success: true,
      message: "折扣码应用成功！",
      code: currentDiscount.code,
      subtotal: cart.estimatedCost.subtotalAmount.amount,
      total: cart.estimatedCost.totalAmount.amount,
      currency: cart.estimatedCost.totalAmount.currencyCode
    };
  } catch (error) {
    console.error("请求失败:", error);
    return { success: false, message: "网络请求失败，请稍后再试" };
  }
}

// ==========================================
// 3. 辅助功能函数
// ==========================================
async function getCurrentCartId() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return `gid://shopify/Cart/${cart.token}`;
  } catch (err) {
    console.error("获取购物车 ID 失败", err);
    return null;
  }
}

function appendDiscountToCheckoutForm(validCode) {
  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    let hiddenInput = cartForm.querySelector('input[name="discount"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'discount';
      cartForm.appendChild(hiddenInput);
    }
    hiddenInput.value = validCode;
  }
}

// ==========================================
// 4. 监听主题原生刷新事件 (改数量、清空购物车)
// ==========================================
document.documentElement.addEventListener("cart:refresh", (event) => {
  const cartData = event.detail.cart;
  if (!cartData) return;

  // 场景 A: 购物车被清空了，必须擦除折扣记忆
  if (cartData.item_count === 0) {
    console.log("购物车已空，清除折扣状态...");
    activeDiscountCode = null;
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
       const hiddenInput = cartForm.querySelector('input[name="discount"]');
       if (hiddenInput) hiddenInput.remove();
    }
    fetch('/discount/CLEAR').catch(() => {}); // 擦除 Shopify Cookie 缓存
    return;
  }

  // 场景 B: 购物车商品数量改变，自动基于新数量重算折扣
  if (activeDiscountCode && cartData.token) {
    console.log(`数量改变，重新计算折扣: ${activeDiscountCode}`);
    
    // 延时 600ms，等待主题原生的 DOM 渲染完毕后再去盖住它
    setTimeout(async () => {
      const myCartId = `gid://shopify/Cart/${cartData.token}`;
      const result = await applyDiscountCode(myCartId, activeDiscountCode);
      
      const msgDiv = document.getElementById('discount-message-new');
      const totalDisplay = document.getElementById('cart-total-display-new');
      if (!msgDiv || !totalDisplay) return;

      if (result.success) {
        const savedAmount = (parseFloat(result.subtotal) - parseFloat(result.total)).toFixed(2);


          // msgDiv.innerHTML = `${result.message} <br> <div class="discount_codes">为您节省了 ${savedAmount} ${result.currency}</div>`;
          // msgDiv.style.color = "green";
          // totalDisplay.innerHTML = `
          //   <div class="discount_price-new">${result.subtotal} ${result.currency}</div>
          //   <div class="price-new">${result.total} ${result.currency}</div>
          // `;


        appendDiscountToCheckoutForm(result.code);
      } else {
        // msgDiv.innerText = `不满足折扣条件：${result.message}`;
        msgDiv.style.color = "red";
        if (result.totalAmount) {
        //    totalDisplay.innerHTML = `<div class="error__txt">${result.totalAmount}</div>`;
        }
        activeDiscountCode = null; 
      }
    }, 600); 
  }
});

// ==========================================
// 5. 事件代理：处理用户主动点击“应用折扣”按钮
// ==========================================
document.body.addEventListener('click', async (e) => {
  const applyBtn = e.target.closest('#apply-discount-btn-new');
  if (!applyBtn) return;

  e.preventDefault();

  const codeInput = document.getElementById('cart-discount-input-new');
  let msgDiv = document.getElementById('discount-message-new');
  let totalDisplay = document.getElementById('cart-total-display-new');

  if (!codeInput || !msgDiv || !totalDisplay) return;

  const codeValue = codeInput.value.trim();

  if (!codeValue) {
    msgDiv.innerText = "请输入折扣码";
    msgDiv.style.color = "red";
    return;
  }

  applyBtn.disabled = true;
  applyBtn.classList.add('is-loading'); 
  msgDiv.innerText = ""; 

  try {
    const myCartId = await getCurrentCartId();
    if (!myCartId) throw new Error("购物车状态异常");

    // 调用 GraphQL 验证代码
    const result = await applyDiscountCode(myCartId, codeValue);

    if (result.success) {
      activeDiscountCode = result.code;
      appendDiscountToCheckoutForm(result.code);

      const resCart = await fetch('/cart.js');
      const cartData = await resCart.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true, 
        detail: { cart: cartData }
      }));

      setTimeout(() => {
        msgDiv = document.getElementById('discount-message-new'); 
        totalDisplay = document.getElementById('cart-total-display-new');
        
        if (msgDiv && totalDisplay) {
          const savedAmount = (parseFloat(result.subtotal) - parseFloat(result.total)).toFixed(2);
          // msgDiv.innerHTML = `✅ ${result.message} <br> <div class="discount_codes">为您节省了 ${savedAmount} ${result.currency}</div>`;
          // msgDiv.style.color = "green";
          // totalDisplay.innerHTML = `
          //   <div class="discount_price-new">${result.subtotal} ${result.currency}</div>
          //   <div class="price-new">${result.total} ${result.currency}</div>
          // `;
        }
      }, 500); 

    } else {
      msgDiv.innerText = `❌ ${result.message}`;
      msgDiv.style.color = "red";
      if (result.totalAmount) {
        //  totalDisplay.innerHTML = `<div class="error__txt">${result.totalAmount}</div>`;
      }
      activeDiscountCode = null;
      applyDiscountCode(myCartId, "").catch(()=>{});
    }
  } catch (error) {
    msgDiv.innerText = "网络异常，请重试";
    msgDiv.style.color = "red";
  } finally {
    // 移除 Loading 动画
    applyBtn.disabled = false;
    applyBtn.classList.remove('is-loading');
  }
});